"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useTouch2 = _interopRequireDefault(require("../useTouch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var onSwipeBack = function onSwipeBack(listener, options) {
  // 仅注册一次事件即可
  if (onSwipeBack._registered) return;
  onSwipeBack._registered = true;
  var target = window;
  var delay = (options === null || options === void 0 ? void 0 : options.delay) || 200;
  var documentWidth = document.documentElement.clientWidth || document.body.clientWidth || 0;
  var _useTouch = (0, _useTouch2.default)(),
    touchData = _useTouch.touchData,
    onTouchStart = _useTouch.onTouchStart,
    onTouchMove = _useTouch.onTouchMove,
    onTouchEnd = _useTouch.onTouchEnd;
  var touchStartHandler = onTouchStart(target, function () {});
  var touchEndHandler = onTouchEnd(target, function () {});
  var touchMoveHandler = onTouchMove(target, delay, function () {
    if (touchData.direction === 'horizontal') {
      var maxOffset = documentWidth * 0.05;
      if (touchData.deltaX < -documentWidth / 2 || touchData.startX <= maxOffset && touchData.offsetX >= maxOffset * 2) {
        listener({
          touchData: touchData,
          removeEventListener: function removeEventListener() {
            _removeEventListener();
          }
        });
      }
    }
  }, {
    capture: true
  });
  var _removeEventListener = function _removeEventListener() {
    touchStartHandler.removeEventListener();
    touchMoveHandler.removeEventListener();
    touchEndHandler.removeEventListener();
    delete onSwipeBack._registered;
  };
  return {
    removeEventListener: _removeEventListener
  };
};
onSwipeBack._registered = false;
var _default = onSwipeBack;
exports.default = _default;